module.exports = __webpack_public_path__ + "img/whiteCross-1.18a9f9e0.svg";